// The answer being written right now, built up from the turn's events. Pure, so the order of
// events is the only thing that decides what the person sees.

import type { ChatEvent, StopReason, ToolStep, TurnUsage } from "../../types/index.ts";

export interface LiveTurn {
  question: string;
  text: string;
  steps: ToolStep[];
  /** The latest "what I'm doing" line, shown until text starts arriving. */
  status: string | null;
  errors: string[];
  stopReason: StopReason | null;
  usage: TurnUsage | null;
  saved: boolean;
}

export function startTurn(question: string): LiveTurn {
  return { question, text: "", steps: [], status: null, errors: [], stopReason: null, usage: null, saved: false };
}

export function applyEvent(turn: LiveTurn, event: ChatEvent): LiveTurn {
  switch (event.type) {
    case "status":
      return { ...turn, status: event.message };
    case "text":
      return { ...turn, text: turn.text + event.delta, status: null };
    case "tool-start":
      if (turn.steps.some((s) => s.id === event.step.id)) return turn;
      return { ...turn, steps: [...turn.steps, event.step] };
    case "tool-end":
      return {
        ...turn,
        steps: turn.steps.map((s) => (s.id === event.id ? { ...s, status: event.ok ? "done" : "failed" } : s)),
      };
    case "error":
      return { ...turn, errors: [...turn.errors, event.message] };
    case "done":
      return { ...turn, stopReason: event.stopReason, usage: event.usage, status: null };
    case "saved":
      return { ...turn, saved: true };
    default:
      return turn;
  }
}
